<template>
    <div>
        <div>
            <div style="display: flex;justify-content: space-between">
                <div style="display: flex;justify-content: space-between">
                    <span style="width:200px;">付款数：{{static.count}}</span>
                    <span style="width:200px;">总金额：{{static.total}}</span>
                </div>
                <div v-if="cookieTemp == '已失效'">
                    Cookie:
                        <el-input v-model="cookieValue"  placeholder="cookie值" clearable size="mini"
                            style="width: 220px;" @keyup.enter.native="changeCookie"></el-input>
                </div>
                <div>
                    <!-- <el-upload
                            :show-file-list="false"
                            :before-upload="beforeUpload"
                            :on-success="onSuccess"
                            :on-error="onError"
                            :disabled="importDataDisabled"
                            style="display: inline-flex;margin-right: 8px"
                            action="/employee/basic/import">
                        <el-button :disabled="importDataDisabled" type="success" :icon="importDataBtnIcon">
                            {{importDataBtnText}}
                        </el-button>
                    </el-upload> -->
                    <el-button type="primary" icon="el-icon-plus" @click="showAddEmpView">
                        添加
                    </el-button>
                </div>
            </div>
            <transition name="slide-fade">
                <div v-show="showAdvanceSearchView"
                     style="border: 1px solid #409eff;border-radius: 5px;box-sizing: border-box;padding: 5px;margin: 10px 0px;">
                    <el-row>
                        <el-col :span="5">
                            企业名称:
                            <el-input v-model="searchValue.memo" placeholder="企业名称" clearable size="mini"
                                       style="width: 220px;"></el-input>
                        </el-col>
                        <el-col :span="5">
                            订单号:
                            <el-input v-model="searchValue.merOrderId" placeholder="订单号" clearable size="mini"
                                       style="width: 220px;"></el-input>
                        </el-col>
                        <el-col :span="4">
                            是否开票:
                            <el-select v-model="searchValue.invoiceStatus" clearable="" placeholder="请选择" size="mini"
                                       style="width: 100px;">
                                <el-option
                                        key="0"
                                        label="未开票"
                                        value="0">
                                </el-option>
                                <el-option
                                        key="1"
                                        label="已开票"
                                        value="1">
                                </el-option>
                                <el-option
                                        key="2"
                                        label="未申请"
                                        value="2">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="3">
                            付款状态:
                            <el-select v-model="searchValue.isBack" clearable="" placeholder="请选择" size="mini"
                                       style="width: 100px;">
                                <el-option
                                        key="0"
                                        label="正常"
                                        :value="0">
                                </el-option>
                                <el-option
                                        key="1"
                                        label="退款"
                                        :value="1">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row style="margin-top: 10px;">
                        <el-col :span="8">
                            支付时间:
                            <el-date-picker
                                    v-model="searchValue.beginDateScope"
                                    type="datetimerange"
                                    size="mini"
                                    unlink-panels
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                            </el-date-picker>
                        </el-col>

                       
                        <el-col :span="4" :offset="4">
                            <el-button size="mini"  @click="reset()">取消</el-button>
                            <el-button size="mini" icon="el-icon-search" type="primary" @click="initEmps('advanced')">搜索</el-button>
                        </el-col>
                    </el-row>
                </div>
            </transition>
        </div>
        <!-- 标题列 --->
        <div style="margin-top: 10px">
            <el-table
                    :data="emps"
                    stripe
                    border
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    ref="projectTable"
                    style="width: 100%"
                    :row-key="row=>row.businessCode"
                    @selection-change="handleSelectionChange"
                    :header-cell-style="{'text-align':'center'}">
                   
                <!-- <el-table-column
                        type="selection" :reserve-selection="true"
                        width="55">
                </el-table-column> -->
                <el-table-column
                        prop="memo"
                        fixed
                        align="left"
                        label="付款企业名称"
                        width="190"
                        :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="payTime"
                        width="160"
                        align="center"
                        label="付款时间">
                </el-table-column>
                <el-table-column
                        prop="totalAmount"
                        width="80"
                        align="center"
                        label="付款金额">
                </el-table-column>
                <el-table-column
                        prop="contactInfo"
                        width="120"
                        align="center"
                        label="联系方式"
                        :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="mark"
                        width="120"
                        align="center"
                        label="备注"
                        :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="targetSys"
                        width="80"
                        align="center"
                        label="支付渠道">
                </el-table-column>
                <el-table-column
                        prop="merOrderId"
                        width="230"
                        align="center"
                        label="订单号">
                </el-table-column>
                <el-table-column
                        prop="mchntName"
                        width="180"
                        align="center"
                        label="收款企业名称">
                </el-table-column>
                <el-table-column
                        prop="status"
                        width="80"
                        align="center"
                        label="支付状态">
                </el-table-column>
                <el-table-column
                        prop="invoiceStatus"
                        width="80"
                        align="center"
                        label="开票状态">
                        <template slot-scope="scope" >
                            <span v-if="scope.row.invoiceStatus == 0">未开票</span>
                            <span v-else-if="scope.row.invoiceStatus == 1">已开票</span>
                            <span v-else>未申请</span>
                         </template>
                </el-table-column>
                <el-table-column
                        prop="cTime"
                        width="160"
                        align="center"
                        label="同步时间">
                </el-table-column>
                 
                <el-table-column
                        fixed="right"
                        align="center"
                        width="260"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button @click="makeSureInvoice(scope.row)" v-if="scope.row.invoiceStatus == 0" style="padding: 3px" size="mini">已开票</el-button>
                        <el-button @click="backOrder(scope.row)" v-if="scope.row.isBack == 0" style="padding: 3px" size="mini">退款</el-button>
                        <el-button @click="showEditEmpView(scope.row)" style="padding: 3px" size="mini" type="danger">编辑</el-button>
                        <el-button @click="deleteEmp(scope.row)" style="padding: 3px" size="mini" type="danger">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: flex-end">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>
        <!-- 上传项目文件弹窗 -->
        <!--================================上传文件弹窗=========================-->
        <el-dialog :title="addFileTitleName" :visible.sync="importDataDisabled" width="500px" style="padding:0;" @close="resetAddFile" >
             <div class="add-file-right" >
                <el-col :span="24">
                    下单平台:<el-select v-model="upFilePlat" clearable="" placeholder="下单平台" size="mini">
                        <el-option
                                v-for="item in platList"
                                :key="item.dictValue"
                                :label="item.dictLabel"
                                :value="item.dictValue">
                        </el-option>
                    </el-select>
                </el-col>
            </div>
            <!-- <el-input v-model="addFileName" autocomplete="off" size="small" style="width: 300px; display: none;" ></el-input> -->
           
            <div class="add-file-right" style="margin-top: 20px;">
                <input type="file" ref="clearFile" @change="getFile($event)" multiple="multiplt" class="add-file-right-input" style="margin-left:60px;margin-top: 20px;" accept=".xlsx">
                <div style="margin-top: 20px;">
                    <span class="add-file-right-more">支持扩展名：.xlsx</span>
                </div>
                <div style="margin-top: 10px;">
                    <span class="add-file-right-more">注意：表中必须含有"项目名称"字段,前程和销售单需要注意</span>
                </div>
            </div>
            <div class="add-file-list">
                <ul>
                    <li v-for="(item, index) in addArr" :key="index"><a >{{item.name}}</a></li>
                </ul>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitAddFile" size="small">开始上传</el-button>
                <el-button @click="resetAddFile" size="small">全部删除</el-button>
            </div>
            
        </el-dialog>


        <el-dialog
                :title="title"
                :visible.sync="dialogVisible"
                width="80%">
            <div>
                <el-form :model="emp" label-position="right" label-width="120px"  :rules="rules" ref="empForm">
                            <el-form-item label="企业名称:" prop="memo">
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.memo"
                                          placeholder="请输入企业名称"></el-input>
                            </el-form-item>
                            <el-form-item label="付款金额:" prop="totalAmount">
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.totalAmount"
                                          placeholder="付款金额"></el-input>
                            </el-form-item>
                            <el-form-item label="联系方式:" prop="contactInfo">
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.contactInfo"
                                          placeholder="联系方式"></el-input>
                            </el-form-item>
                            <el-form-item label="开票状态:" prop="invoiceStatus">
                                <el-select v-model="emp.invoiceStatus" clearable="" placeholder="请选择" size="mini"
                                        style="width: 100px;">
                                    <el-option
                                            key="0"
                                            label="未开票"
                                            :value="0">
                                    </el-option>
                                    <el-option
                                            key="1"
                                            label="已开票"
                                            :value="1">
                                    </el-option>
                                    <el-option
                                            key="2"
                                            label="未申请"
                                            :value="2">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="备注:" prop="mark">
                                <el-input type="textarea" size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.mark"
                                          placeholder="备注"></el-input>
                            </el-form-item>
                            <el-form-item label="支付时间:" prop="payTime">
                                <el-date-picker
                                        v-model="emp.payTime"
                                        size="mini"
                                        type="datetime"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        style="width: 150px;"
                                        placeholder="支付时间">
                                </el-date-picker>
                            </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="doAddEmp">确 定</el-button>
  </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "projectInfo",
        data() {
            return {
               
                searchValue: {
                    politicId: null,
                    nationId: null,
                    jobLevelId: null,
                    posId: null,
                    engageForm: null,
                    departmentId: null,
                    isBack: 0,
                    beginDateScope: null
                },
                typeList: [{
                    dictValue: '01',
                    dictLabel: '微信'
                    }, {
                    dictValue: '02',
                    dictLabel: 'QQ'
                    }, {
                    dictValue: '03',
                    dictLabel: '公众号'
                }],
                platList: [{
                    dictValue: '01',
                    dictLabel: '智联'
                    }, {
                    dictValue: '02',
                    dictLabel: '前程'
                    }, {
                    dictValue: '03',
                    dictLabel: '猎聘'
                    }, {
                    dictValue: '04',
                    dictLabel: '销售'
                }],
                sourceList: [
                    {
                        dictValue: '01',
                        dictLabel: '自然流量'
                    }, 
                    {
                        dictValue: '02',
                        dictLabel: '销售引入'
                    }
                ],
                title: '',
                static:{

                },
                importDataBtnText: '导入数据',
                importDataBtnIcon: 'el-icon-upload2',
                importDataDisabled: false,
                showAdvanceSearchView: true,
                allDeps: [],
                upFilePlat:'',
                addFileTitleName: "上传文件窗口",
                addFileName: "",
                addArr: [],
                emps: [],
                loading: false,
                popVisible: false,
                popVisible2: false,
                dialogVisible: false,
                total: 0,
                page: 1,
                keyword: '',
                size: 10,
                nations: [],
                joblevels: [],
                politicsstatus: [],
                positions: [],
                cookieValue:'',
                cookieTemp:'',
                tiptopDegrees: ['本科', '大专', '硕士', '博士', '高中', '初中', '小学', '其他'],
                options: [{
                    value: '选项1',
                    label: '黄金糕'
                }, {
                    value: '选项2',
                    label: '双皮奶'
                }, {
                    value: '选项3',
                    label: '蚵仔煎'
                }, {
                    value: '选项4',
                    label: '龙须面'
                }, {
                    value: '选项5',
                    label: '北京烤鸭'
                }],
                inputDepName: '所属部门',
                emp: {
                    name: "javaboy",
                    gender: "男",
                    birthday: "1989-12-31",
                    idCard: "610122199001011256",
                    wedlock: "已婚",
                    nationId: 1,
                    nativePlace: "陕西",
                    politicId: 13,
                    email: "laowang@qq.com",
                    phone: "18565558897",
                    address: "深圳市南山区",
                    departmentId: null,
                    jobLevelId: 9,
                    posId: 29,
                    engageForm: "劳务合同",
                    tiptopDegree: "本科",
                    specialty: "信息管理与信息系统",
                    school: "深圳大学",
                    beginDate: "2017-12-31",
                    workState: "在职",
                    workID: "00000057",
                    contractTerm: 2,
                    conversionTime: "2018-03-31",
                    notworkDate: null,
                    beginContract: "2017-12-31",
                    endContract: "2019-12-31",
                    workAge: null
                },
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                rules: {
                    memo: [{required: true, message: '请输入企业名称', trigger: 'change'}],
                    totalAmount: [{required: true, message: '请输入金额', trigger: 'blur'},{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)|(^[0-9]\.[0-9]([0-9])([0-9])?$)/, message: '请输入正确的格式,可保留三位小数' }],
                    payTime: [{required: true, message: '请选择交易时间', trigger: 'blur'}],
                    name: [{required: true, message: '请输入用户名', trigger: 'blur'}],
                    gender: [{required: true, message: '请输入性别', trigger: 'blur'}],
                    birthday: [{required: true, message: '请输入出生日期', trigger: 'blur'}],
                    idCard: [{required: true, message: '请输入身份证号码', trigger: 'blur'}, {
                        pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
                        message: '身份证号码格式不正确',
                        trigger: 'blur'
                    }],
                    wedlock: [{required: true, message: '请输入婚姻状况', trigger: 'blur'}],
                    nationId: [{required: true, message: '请输入您组', trigger: 'blur'}],
                    nativePlace: [{required: true, message: '请输入籍贯', trigger: 'blur'}],
                    politicId: [{required: true, message: '请输入政治面貌', trigger: 'blur'}],
                    email: [{required: true, message: '请输入邮箱地址', trigger: 'blur'}, {
                        type: 'email',
                        message: '邮箱格式不正确',
                        trigger: 'blur'
                    }],
                    phone: [{required: true, message: '请输入电话号码', trigger: 'blur'}],
                    address: [{required: true, message: '请输入员工地址', trigger: 'blur'}],
                    departmentId: [{required: true, message: '请输入部门名称', trigger: 'blur'}],
                    jobLevelId: [{required: true, message: '请输入职称', trigger: 'blur'}],
                    posId: [{required: true, message: '请输入职位', trigger: 'blur'}],
                    engageForm: [{required: true, message: '请输入聘用形式', trigger: 'blur'}],
                    tiptopDegree: [{required: true, message: '请输入学历', trigger: 'blur'}],
                    specialty: [{required: true, message: '请输入专业', trigger: 'blur'}],
                    school: [{required: true, message: '请输入毕业院校', trigger: 'blur'}],
                    beginDate: [{required: true, message: '请输入入职日期', trigger: 'blur'}],
                    workState: [{required: true, message: '请输入工作状态', trigger: 'blur'}],
                    workID: [{required: true, message: '请输入工号', trigger: 'blur'}],
                    contractTerm: [{required: true, message: '请输入合同期限', trigger: 'blur'}],
                    conversionTime: [{required: true, message: '请输入转正日期', trigger: 'blur'}],
                    notworkDate: [{required: true, message: '请输入离职日期', trigger: 'blur'}],
                    beginContract: [{required: true, message: '请输入合同起始日期', trigger: 'blur'}],
                    endContract: [{required: true, message: '请输入合同结束日期', trigger: 'blur'}],
                    workAge: [{required: true, message: '请输入工龄', trigger: 'blur'}],
                }
            }
        },
        mounted() {
            this.initEmps();
            this.initData();
        },
        methods: {
            changeCookie(){
                this.putRequest("/yl/business/cookie" ,{cookie:this.cookieValue}).then(resp => {
                        if (resp) {
                            this.initEmps();
                        }
                    })
            },
            searvhViewHandleNodeClick(data) {
                this.inputDepName = data.name;
                this.searchValue.departmentId = data.id;
                this.popVisible2 = !this.popVisible2
            },
            rowKey(row){
                console.log( row.projectCode)
                row.projectCode;
            },
            handleSelectionChange (val) {
                console.log(val)
            },
            showEditEmpView(data) {
                // this.initPositions();
                this.title = '编辑订单信息';
                this.emp = data;
                // this.inputDepName = data.department.name;
                this.dialogVisible = true;
            },
            //1、使用插槽（推荐）
            getChangeType(e,z) {

                if('type' == z){
                    for (var i = 0; i < this.typeList.length; i++) {
                        if (this.typeList[i].dictValue == e) { //dictValue，dictLabel保持和上面定义一致
                            return this.typeList[i].dictLabel;
                        }
                    }
                }else if('plat' == z){
                    for (var i = 0; i < this.platList.length; i++) {
                        if (this.platList[i].dictValue == e) { //dictValue，dictLabel保持和上面定义一致
                            return this.platList[i].dictLabel;
                        }
                    }
                }else if('source' == z){
                    for (var i = 0; i < this.sourceList.length; i++) {
                        if (this.sourceList[i].dictValue == e) { //dictValue，dictLabel保持和上面定义一致
                            return this.sourceList[i].dictLabel;
                        }
                    }
                }
               
            },

            onError(err, file, fileList) {
                this.importDataBtnText = '导入数据';
                this.importDataBtnIcon = 'el-icon-upload2';
                this.importDataDisabled = false;
            },
            onSuccess(response, file, fileList) {
                this.importDataBtnText = '导入数据';
                this.importDataBtnIcon = 'el-icon-upload2';
                this.importDataDisabled = false;
                this.initEmps();
            },
            beforeUpload() {
                this.importDataBtnText = '正在导入';
                this.importDataBtnIcon = 'el-icon-loading';
                this.importDataDisabled = true;
            },
            importData(){
                this.importDataDisabled = true;
            },
            exportData() {
                let a = this.$refs.projectTable.selection
                window.open('/employee/basic/export', '_parent');
            },
            exportTask() {
                let selected = this.$refs.projectTable.selection
                let arr = [];
                for(let temp in selected){
                    arr.push(selected[temp].projectCode)

                }
                window.open('/employee/basic/export', '_parent');
            },
            emptyEmp() {
                this.emp = {
                    name: "",
                }
                this.inputDepName = '';
            },
            makeSureInvoice(data) {
                this.putRequest("/yl/business/order/invoice" ,data).then(resp => {
                        if (resp) {
                            this.initEmps();
                        }
                    })
            },
            backOrder(data) {
                this.putRequest("/yl/business/order/back" ,data).then(resp => {
                        if (resp) {
                            this.initEmps();
                        }
                    })
            },
            deleteEmp(data) {
                this.$confirm('此操作将永久删除【' + data.memo + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest("/yl/business/" + data.businessCode).then(resp => {
                        if (resp) {
                            this.initEmps();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            doAddEmp() {
                if (this.emp.id) {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.putRequest("/yl/business/order", this.emp).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }
                    });
                } else {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/yl/business/order", this.emp).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }
                    });
                }
            },
            reset(){
                this.searchValue = {isBack:0};
                this.initEmps('abs');
            },
            handleNodeClick(data) {
                this.inputDepName = data.name;
                this.emp.departmentId = data.id;
                this.popVisible = !this.popVisible
            },
            showDepView() {
                this.popVisible = !this.popVisible
            },
            showDepView2() {
                this.popVisible2 = !this.popVisible2
            },
            initData() {
                
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initEmps();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initEmps('advanced');
            },
            showAddEmpView() {
                this.emptyEmp();
                this.title = '添加项目';
                this.dialogVisible = true;
            },
            initEmps(type) {
                this.loading = true;
                // let reqParam = {projectNameLike:this.keyword};
                if(type === 'abs'){
                    this.page=1
                } 
                this.searchValue['pageNo']=this.page
                this.searchValue['pageSize']=this.size
                this.postRequest('/yl/business/orders', this.searchValue).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.emps = resp.data;
                        this.total = resp.total;
                    }
                });

                this.getRequest('/yl/business/order/static').then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.static = resp.obj[0];
                    }
                });

                this.getRequest('/yl/business/cookie').then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.cookieValue = resp.obj;
                        this.cookieTemp = resp.obj;
                    }
                });

            },
            //==================上传文件操作函数=============================================
            getFile(event){  
                //获取上传文件方法    
                var file = event.target.files;    
                for(var i = 0;i<file.length;i++){        
                    //    上传类型判断        
                    var imgName = file[i].name;        
                    var idx = imgName.lastIndexOf(".");        
                    if (idx != -1){            
                        var ext = imgName.substr(idx+1).toUpperCase();            
                        ext = ext.toLowerCase( );            
                        //pdg,doc,docx.xls,.xlsx,.ppt,pptx,            
                        if (ext!='xlsx'){

                        }else{
                            this.addArr.push(file[i]);            
                        }        
                    }else{        

                    }    
                }},
            submitAddFile(){    
                //===========提交上传文件到后台保存方法    
                if(0 == this.addArr.length){        
                    this.$message({            
                        type: 'info',            
                        message: '请选择要上传的文件'        
                    });        
                    return;    
                }    
                var formData = new FormData();    
                for(var i=0;i<this.addArr.length;i++){        
                    formData.append('files',this.addArr[i]); 
                }  
                formData.append('plat',this.upFilePlat);      
                let config = {        
                    headers: { "Content-Type": "multipart/form-data" }    
                };    
                console.log(formData);　　
                //接口请求使用的是自己封装了一下的axios    
                this.postRequest('/yl/qun/importProject', formData, config).then(res => {
                    console.log(res);        
                    this.$message({            
                        message: '操作成功',            
                        type: 'success'        
                    });    
                }).catch((error) => {        
                    alert("操作失败，出现错误：" + error)    
                });
            },
            //清除上传的文件方法
            resetAddFile(){   
                this.addFileName = "";    
                this.addArr =[];
                this.upFilePlat = "";
                this.$refs.clearFile.value =''
            },

        }
    }
</script>

<style>
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
</style>
